// extracted by mini-css-extract-plugin
module.exports = {"buttonDefault":"styles_buttonDefault__B5nz5"};